import Splide from '@splidejs/splide';

// DOM loaded
document.addEventListener("DOMContentLoaded", () => {

    // =========================================================
    // 1. CARROUSELS GÉNÉRIQUES (.pdw-carousel)
    // =========================================================
    const carousels = document.querySelectorAll('.pdw-carousel');
    const splideInstances = [];

    carousels.forEach((item) => {
        const dataPerviewDefault = parseInt(item.dataset.perview, 10) || 1;

        const dataPerview = {
            9999: parseInt(item.dataset.perviewxxl, 10),
            1399: parseInt(item.dataset.perviewxl, 10),
            1199: parseInt(item.dataset.perviewlg, 10),
            991: parseInt(item.dataset.perviewmd, 10),
            767: parseInt(item.dataset.perviewsm, 10),
            575: parseInt(item.dataset.perviewxs, 10)
        };

        const breakPoints = {};
        Object.keys(dataPerview).forEach(key => {
            if (Number.isInteger(dataPerview[key])) {
                breakPoints[key] = { perPage: dataPerview[key] };
            } else {
                if (key === '767') {
                    breakPoints[key] = { perPage: 1 };
                }
                if (key === '991') {
                    breakPoints[key] = { perPage: (dataPerviewDefault > 1) ? dataPerviewDefault - 1 : 1 };
                }
            }
        });

        const dataType = item.dataset.type || 'loop';
        const dataGap = parseInt(item.dataset.gap, 10) || 0;
        const dataPeekBefore = parseInt(item.dataset.peekbefore, 10) || 0;
        const dataPeekAfter = parseInt(item.dataset.peekafter, 10) || 0;

        const conf = {
            type: dataType,
            arrows: true,
            pagination: true,
            rewind: false,
            perPage: dataPerviewDefault,
            perMove: 1,
            gap: `${dataGap}px`,
            autoplay: false,
            breakpoints: breakPoints,
            padding: {
                left: dataPeekBefore,
                right: dataPeekAfter
            }
        };

        const mainSplide = new Splide(item, conf);
        splideInstances.push(mainSplide);

        const carouselCounters = item.querySelectorAll('.pdw-carousel-counter > .splide');
        if (carouselCounters.length > 0) {
            const confCounter = {
                perPage: 1, type: 'fade', rewind: true, isNavigation: true,
                gap: 0, focus: 'center', pagination: false, arrows: false
            };
            carouselCounters.forEach((counter) => {
                const counterSplide = new Splide(counter, confCounter);
                mainSplide.sync(counterSplide);
                splideInstances.push(counterSplide);
            });
        }

        const carouselThumbnails = item.querySelectorAll('.pdw-carousel-thumbnails');
        if (carouselThumbnails.length > 0) {
            const confThumbnails = {
                perPage: 1, perMove: 1, type: 'loop', rewind: true, isNavigation: true,
                gap: 10, pagination: false, arrows: true, direction: 'ttb',
                fixedWidth: 100, fixedHeight: 100, height: '100vh'
            };
            carouselThumbnails.forEach((thumbnails) => {
                const thumbSplide = new Splide(thumbnails, confThumbnails);
                mainSplide.sync(thumbSplide);
                splideInstances.push(thumbSplide);
            });
        }
    });

    // =========================================================
    // 2. GALERIE PRODUIT (Transformation dynamique en Splide)
    // =========================================================
    // On cible le conteneur principal de façon plus large pour éviter les erreurs
    const mainImageContainer = document.querySelector('.product-gallery-main-image');
    const thumbnailsCarouselEl = document.querySelector('.product-gallery-thumbnail-carousel');

    if (mainImageContainer && thumbnailsCarouselEl) {

        const thumbnailButtons = thumbnailsCarouselEl.querySelectorAll('.product-gallery-thumbnail-button');
        const slidesHTML = [];

        // Création des slides pour l'image principale depuis les attributs des miniatures
        thumbnailButtons.forEach((btn) => {
            const img = btn.querySelector('img');
            if (img) {
                const fullSrc = img.getAttribute('data-full-src') || img.src;
                const fullAlt = img.getAttribute('data-full-alt') || img.alt;

                slidesHTML.push(`
                    <li class="splide__slide h-100">
                        <img src="${fullSrc}" alt="${fullAlt}" class="w-100 h-100 object-fit-cover pdw-rounded">
                    </li>
                `);
            }
        });

        // Remplacement de l'image de base (uniquement la balise img) par la structure Splide
        const oldMainImage = mainImageContainer.querySelector('img');
        
        if (oldMainImage) {
            oldMainImage.outerHTML = `
                <div id="main-product-splide" class="splide h-100">
                    <div class="splide__track h-100">
                        <ul class="splide__list h-100">
                            ${slidesHTML.join('')}
                        </ul>
                    </div>
                </div>
            `;
        }

        // Instanciation du carrousel principal
        const mainProductSplide = new Splide('#main-product-splide', {
            type: 'slide',
            rewind: true,
            pagination: false,
            arrows: false,
            updateOnMove: true, // 🚀 Met à jour les classes actives PENDANT le glissement
        });

        // Instanciation du carrousel des miniatures
        const thumbnailsSplide = new Splide('.product-gallery-thumbnail-carousel', {
            gap: '16px',
            padding: { left: '0px', right: '0px' },
            arrows: false,
            perPage: 6,
            pagination: false,
            isNavigation: true,
            focus: 'center',
            slideFocus: false,
            updateOnMove: true, // 🚀 Assure que les classes is-visible sont réactives
        });

        // Synchronisation AVANT le montage
        mainProductSplide.sync(thumbnailsSplide);

        // 🚀 RESTAURATION : Remise en place de l'attribut aria-current pour ton CSS (AVANT mount)
        mainProductSplide.on('active', (slide) => {
            // Retire l'état actif de tous les boutons
            document.querySelectorAll('.product-gallery-thumbnail-button[aria-current="true"]').forEach(btn => {
                btn.removeAttribute('aria-current');
            });

            // Ajoute l'état actif au nouveau bouton
            const newActiveBtn = thumbnailButtons[slide.index];
            if (newActiveBtn) {
                newActiveBtn.setAttribute('aria-current', 'true');
            }
        });

        // Montage des carrousels
        mainProductSplide.mount();
        thumbnailsSplide.mount();

        // Gestion de tes flèches personnalisées
        const prevButton = document.querySelector('.product-gallery-thumbnails-track .product-gallery-previous-button');
        const nextButton = document.querySelector('.product-gallery-thumbnails-track .product-gallery-next-button');

        if (prevButton) prevButton.addEventListener('click', () => mainProductSplide.go('<'));
        if (nextButton) nextButton.addEventListener('click', () => mainProductSplide.go('>'));
    }

    // =========================================================
    // 3. MONTAGE DES CARROUSELS GÉNÉRIQUES
    // =========================================================
    splideInstances.forEach(instance => instance.mount());


});